const RangeSliderPlugin = {
    init: ($) => {
        if ($.fn.slider) {
            $('[data-plugin="range-slider"]').slider({});
        }
    },
};

export default RangeSliderPlugin;
